export default {
  error: 'Something went wrong',
  // MUTATIONS
  AddPeriodicEvent: 'Failed to create meeting series',
  AddSingleEvent: 'Failed to create a meeting',
  AddEmployeeWorkingHours: 'Failed to add employee working hours',
  EditEvent: 'Failed to update the meeting',
  EditAddress: 'Failed to update the address',
  CreateEmployee: 'Failed to create an employee',
  CreateEmployeePreferredRooms: 'Failed to update an employee',
  CreateEmployeeRoles: 'Failed to update an employee',
  EditEmployee: 'Failed to update an employee',
  UpdateWorkingTimes: 'Failed to update working times',
  AddGroup: 'Failed to create a group',
  AddGroupMembers: 'Failed to add group members',
  DeactivateGroup: 'Failed to deactivate a group',
  AddCouple: 'Failed to create a couple',
  AddPatient: 'Failed to create a patient',
  DeactivatePatient: 'Failed to deactivate a patient',
  EditPatient: 'Failed to update a patient',
  AddPatientPsychotherapy: "Failed to update patient's psychotherapy notes",
  EditPatientPsychotherapy: "Failed to update patient's psychotherapy notes",
  AddPatientSpeechTherapy: "Failed to update patient's speech therapy notes",
  EditPatientSpeechTherapy: "Failed to update patient's speech therapy notes",
  CreateGuardian: 'Failed to create a guardian',
  DeactivateGuardian: 'Failed to deactivate a guardian',
  EditGuardian: 'Failed to update a guardian',
  EditPatientAddress: 'Failed to update a patient address',
  EditPatientGuardianAddress: 'Failed to update a patient guardian address',
  EditPractice: 'Failed to update a practice',
  AddRoom: 'Failed to create a room',
  DeleteRoomPreferredEmployees: 'Failed to update a room',
  DeleteRoomRestrictedServices: 'Failed to update a room',
  EditRoom: 'Failed to update a room',
  CreateService: 'Failed to create a service',
  EditService: 'Failed to update a service',
  DeactivateService: 'Failed to deactivate a service',
  DeactivateServices: 'Failed to deactivate services',
  AssignEmployeesToService: 'Failed to assign employees to a service',
  DeactivateUser: 'Failed to deactivate a user',
  UpdateUserSettings: 'Failed to update user settings',
  ConfirmMeetingRequest:
    'Failed to confirm a meeting. The same therapist occupy this slot or this room is taken',
  // QUERIES
  GetEvent: 'Failed to fetch a meeting',
  GetEventDetails: 'Failed to fetch a meeting',
  GetEvents: 'Failed to fetch meetings',
  GetPaginatedEvents: 'Failed to fetch meetings',
  GetEmployees: 'Failed to fetch employees',
  GetGroups: 'Failed to fetch groups',
  GetCouples: 'Failed to fetch couples',
  GetPatients: 'Failed to fetch patients',
  GetPatientDetails: 'Failed to fetch a patient',
  GetPracticeDetails: 'Failed to fetch practice details',
  GetRooms: 'Failed to fetch rooms',
  GetServices: 'Failed to fetch services',
}
